module.exports = "../../static/img/background.37fc976.jpg";